import React from 'react';
import { Section } from './Shared';
import { PhoneFrame } from './PhoneFrame';
const INSIDE_VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/bxQg1ky26mN7QtGnfk1vWy/Scroll_Italiano_Qi_Gong_Optimizado_Magic_Partners_U15.mp4';
const included = ['Lezioni già strutturate e pronte da utilizzare come base', 'Criteri per organizzare apertura, sviluppo e chiusura dell’incontro', 'Riferimenti visivi per spiegare meglio posizioni e movimenti', 'Strumenti per adattare la pratica a gruppi, livelli e spazi diversi', 'Schede per osservare, registrare e seguire il percorso degli allievi'];
export const InsideLook = () => <Section id="inside" className="max-w-4xl" data-id="element-128" data-mp="2h7au24cftdee">
    <div className="text-center mb-8" data-id="element-129" data-mp="2m7716cgflky6">
      <h2 className="font-seal text-sm md:text-xl uppercase tracking-seal text-brand-burgundy" data-id="element-130" data-mp="2m65h5ihfto4b">
        Mega Pack Qi Gong™
      </h2>
      <p className="mt-5 mx-auto max-w-2xl font-display text-lg md:text-2xl leading-snug text-brand-textLight" data-id="element-131" data-mp="39uolxo1a3irn">
        Conoscere molti esercizi non significa automaticamente sapere come
        costruire una lezione efficace. Il vero lavoro dell’istruttore è
        collegare obiettivi, movimenti, tempi e progressioni in un percorso
        comprensibile per ogni gruppo.
      </p>
    </div>

    <ul className="mx-auto mb-12 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-132" data-mp="2bn0472jo0vtt">
      {included.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-133" data-mp="2ljv15h0aio5z">
          <span aria-hidden="true" className="mt-2 w-1.5 h-1.5 rotate-45 bg-brand-gold shrink-0" data-id="element-134" data-mp="2li1ptoeqffrn" />
          <span className="text-sm text-brand-text/85" data-id="element-135" data-mp="2ukkorxfed88m">{item}</span>
        </li>)}
    </ul>

    <p className="mx-auto mb-10 max-w-2xl text-center text-sm md:text-base text-brand-muted" data-id="element-136" data-mp="2plgibejuxolz">
      Non è un corso video e non sostituisce la formazione di un istruttore. È
      una biblioteca operativa da consultare mentre prepari le tue lezioni e
      mentre lavori con il gruppo.
    </p>

    <p className="mb-8 text-center font-display italic text-2xl md:text-3xl text-brand-goldDark" data-id="element-137" data-mp="v9tb0sjs3vop">
      Guarda il materiale dall’interno
    </p>

    <div className="relative mx-auto max-w-xl" data-id="element-138" data-mp="309udpcf6nocw">
      <span aria-hidden="true" className="pointer-events-none absolute inset-x-[10%] top-[10%] bottom-[10%] -z-10 rounded-full bg-brand-goldLight/30 blur-3xl" data-id="element-139" data-mp="30amb8sscbw5t" />
      <PhoneFrame data-id="element-140" data-mp="39asj9z59s3xl">
        <video src={INSIDE_VIDEO_URL} className="h-full w-full object-cover" autoPlay muted loop playsInline preload="metadata" aria-label="Anteprima delle pagine interne del Mega Pack Qi Gong, sfogliate da uno smartphone" data-id="element-141" data-mp="3e8kcqxlkby3w" />
      </PhoneFrame>

      <p className="mt-6 text-center text-xs md:text-sm text-brand-muted" data-id="element-142" data-mp="3sxq98dt0na83">
        Un passaggio reale tra le pagine del sistema
      </p>
    </div>
  </Section>;